// import React, { useEffect, useRef, useState } from "react";
// import classes from "./GamePage.module.css";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { getGameData } from "../http/http";
// import Loader from "../components/Player/UI/Loader/Loader";
// import Spinner from "../components/Player/UI/Loader/Spinner";

// const GamePage = () => {
//   const [searchParams] = useSearchParams();
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const iframeRef = useRef(null);
//   const navigate = useNavigate();

//   const fetchData = async (gid) => {
//     try {
//       setLoading(true);
//       const res = await getGameData(gid);

//       if (res?.data?.data?.length) {
//         setData(res.data.data[0]);
//       } else {
//         // toast.error("Game not found");
//         navigate("/home");
//       }
//     } catch {
//     //   toast.error("Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const gameId = searchParams.get("game");
//     if (gameId) fetchData(gameId);
//   }, [searchParams]);

//   if (loading) return null;

//   return (
//     <div className={classes.page}>
//       {/* HEADER */}
//       <header className={classes.header}>
//         <button
//           className={classes.backBtn}
//           onClick={() => navigate("/home")}
//         >
//           {/* <i className={`fa-solid fa-arrow-left ${classes.icon_back}`}/> */}
//           <i className={`pi pi-arrow-left ${classes.icon}`} />
//         </button>
//       </header>

//       {/* GAME */}
//       <main className={classes.gameWrapper}>
//         <iframe
//           ref={iframeRef}
//           src={data?.game_url}
//           className={classes.frame}
//           allow="fullscreen; autoplay; encrypted-media"
//           allowFullScreen
//           title="Game"
//         />
//       </main>
//     </div>
//   );
// };

// export default GamePage;


import React, { useEffect, useRef, useState } from "react";
import classes from "./GamePage.module.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getGameData } from "../http/http";
// import Loader from "../components/Player/UI/Loader/Loader";
import Spinner from "../components/Player/UI/Loader/Spinner";

const GamePage = () => {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState(null);

  const [apiLoading, setApiLoading] = useState(true);
  const [iframeLoading, setIframeLoading] = useState(true);

  const iframeRef = useRef(null);
  const navigate = useNavigate();

  const fetchData = async (gid) => {
    try {
      setApiLoading(true);
      const res = await getGameData(gid);

      if (res?.data?.data?.length) {
        setData(res.data.data[0]);
        setIframeLoading(true); // reset when new game url comes
      } else {
        navigate("/home");
      }
    } catch {
      // navigate("/home");
    } finally {
      setApiLoading(false);
    }
  };

  useEffect(() => {
    const gameId = searchParams.get("game");
    if (gameId) fetchData(gameId);
  }, [searchParams]);

  // Show nothing or a full-screen loader while API loads (your choice)
  if (apiLoading) {
    return (
      <div className={classes.page}>
        <div className={classes.loadingOverlay}>
          <Spinner />
        </div>
      </div>
    );
  }

  return (
    <div className={classes.page}>
      {/* HEADER */}
      <header className={classes.header}>
        <button className={classes.backBtn} onClick={() => navigate("/home")}>
          <i className={`pi pi-arrow-left ${classes.icon}`} />
        </button>
      </header>

      {/* GAME */}
      <main className={classes.gameWrapper}>
        {/* Overlay loader until iframe is ready */}
        {iframeLoading && (
          <div className={classes.loadingOverlay}>
            <Spinner />
          </div>
        )}

        <iframe
          ref={iframeRef}
          src={data?.game_url}
          className={classes.frame}
          allow="fullscreen; autoplay; encrypted-media"
          allowFullScreen
          title="Game"
          onLoad={() => setIframeLoading(false)}
          onError={() => {
            setIframeLoading(false);
            navigate("/home"); // or show error UI instead
          }}
        />
      </main>
    </div>
  );
};

export default GamePage;